import React, { Component } from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as rfqQuotationCrud from '../../../../crud/rfqQuotation.crud';
import Common from '../../../../shared/common';
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter, notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, replyFields, intl) => {
    const formFields = [];

    formFields.push({
        caption: "Request For Quote",
        dataField: 'requestforquotereference',
        required: true,
        dataType: 'string',
    })

    if (fields.Subject.visible) {
        formFields.push({
            caption: fields.Subject.label,
            dataField: 'subject',
            required: fields.Subject.required,
            dataType: 'string'
        })
    }

    if (fields.Description.visible) {
        formFields.push({
            caption: fields.Description.label,
            dataField: 'description',
            required: fields.Description.required,
            dataType: 'long-string'
        })
    }

    if (fields.Comments.visible) {
        formFields.push({
            caption: fields.Comments.label,
            dataField: 'comments',
            required: fields.Comments.required,
            dataType: 'long-string'
        })
    }

    if (fields.ItemsList.visible) {
        formFields.push({
            caption: fields.ItemsList.label,
            dataField: 'itemslist',
            required: fields.ItemsList.required,
            dataType: 'string',
        })
    }

    if (fields.TotalListPrice.visible) {
        formFields.push({
            caption: fields.TotalListPrice.label,
            dataField: 'totallistprice',
            required: fields.TotalListPrice.required,
            dataType: 'integer'
        })
    }
    if (fields.RequestForQuoteDescription.visible) {
        formFields.push({
            caption: fields.RequestForQuoteDescription.label,
            dataField: 'requestforquotedescription',
            required: fields.RequestForQuoteDescription.required,
            dataType: 'string'
        })
    }
    if (fields.TotalAssessed.visible) {
        formFields.push({
            caption: fields.TotalAssessed.label,
            dataField: 'totalassessed',
            required: fields.TotalAssessed.required,
            dataType: 'integer'
        })
    }

    if (fields.StartDate.visible) {
        formFields.push({
            caption: fields.StartDate.label,
            dataField: 'startdate',
            required: fields.StartDate.required,
            dataType: 'date'
        })
    }

    if (fields.CompletionDate.visible) {
        formFields.push({
            caption: fields.CompletionDate.label,
            dataField: 'completiondate',
            required: fields.CompletionDate.required,
            dataType: 'date'
        })
    }

    if (fields.DelayAmount.visible) {
        formFields.push({
            caption: fields.DelayAmount.label,
            dataField: 'delayamount',
            required: fields.DelayAmount.required,
            dataType: 'integer'
        })
    }

    if (fields.DelayPaymentPeriod.visible) {
        formFields.push({
            caption: fields.DelayPaymentPeriod.label,
            dataField: 'delaypaymentperiod',
            required: fields.DelayPaymentPeriod.required,
            dataType: 'list',
            options: {
                dataSource: fields.DelayPaymentPeriod.paymentPeriods
            }
        })
    }

    if (replyFields.ReplyStatus.visible) {
        formFields.push({
            caption: replyFields.ReplyStatus.label,
            dataField: 'status',
            required: replyFields.ReplyStatus.required,
            dataType: 'list',
            options: {
                dataSource: replyFields.ReplyStatus.quoteStatuses,
                valueExpr: 'value',
                displayExpr: 'display'
            },
            isReplyField: true
        })
    }

    if (replyFields.ReplyComment.visible) {
        formFields.push({
            caption: replyFields.ReplyComment.label,
            dataField: 'responsecomment',
            required: replyFields.ReplyComment.required,
            dataType: 'long-string',
            isReplyField: true
        })
    }

    return formFields;
}

class QuoteListPage extends BaseListPage {
    constructor(props) {
        super(props);
        this.quoteStatuses = props.placeholders
            .find(ph => ph.replacementKey === 'QuoteStatuses')
            .values.filter(item => item.isActive === true);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.customFields = [];
        if (props.customFieldsCommon) {
            if (props.customFieldsCommon.RFQQUOTE && props.customFieldsCommon.RFQQUOTE.length > 0) {
                this.customFields.push(...(props.customFieldsCommon.RFQQUOTE.filter(cf => cf.includelisting)));
            }
            if (props.customFieldsCommon.RFQQUOTE_REPLY && props.customFieldsCommon.RFQQUOTE_REPLY.length > 0) {
                this.customFields.push(...(props.customFieldsCommon.RFQQUOTE_REPLY.filter(cf => cf.includelisting)));
            }
        }

        this.batchFormFields = getBatchFormFields(props.workflowItem.fields, props.workflowItem.replyFields, this.props.intl);

        this.state = {
            notifications: null,
            tags: null
        };
    }
    formatCurrency = () => {
        return this.props.contract.currency
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchQuotes2();
    }
    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params.notificationid !== prevprops.params.notificationid) {
            this.fetchQuotes2();
        }
    }
    // fetchQuotes = () => {
    //     const { companyid, projectid, contractid } = this.props.contract;
    //     rfqQuotationCrud.getRfqQuotes(companyid, projectid, contractid, this.props.params.notificationid)
    //         .then(response => {
    //             let quotes = notificationAggregateListTagsFilter(JSON.parse(response.data.aggregatelist));
    //             quotes = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
    //                 quotes :
    //                 quotes.filter(quo => quo.showtasknotification === 1);

    //             let tagFilters = notificationUniqueTagsFilter(JSON.parse(response.data.uniquetags));

    //             this.setState({ notifications: quotes, tags: tagFilters });
    //         })
    //         .catch(err => {
    //             this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
    //         });
    // }
    fetchQuotes2 = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await rfqQuotationCrud.getRfqQuotationReducedV2(
                companyid,
                contractid,
                this.props.params.notificationid,
                this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed);
            let quotes = CustomFieldHelper.MapDataListCustomFieldsToObjectPropertiesV2(responseObj);
            let tagFilters = notificationUniqueTagsFilterV3(this.props.communicationTags);
            this.setState({ notifications: quotes, tags: tagFilters });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }
    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.rfqquotationid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        let status = this.renderStatusDisplay(cellInfo.data);
        if (cellInfo.data.showtasknotification !== 0) {
            switch (cellInfo.data.status) {
                case 1:
                    badgeVariant = 'success';
                    break;
                case 2:
                    badgeVariant = 'warning';
                    break;
                case 0:
                case 3:
                case 4:
                case 5:
                    badgeVariant = 'danger';
                    break;
                case 9:
                    badgeVariant = 'danger';
                    break;
                default:
                    badgeVariant = 'secondary';
                    break;
            }
        }
        return (<Badge variant={badgeVariant}>{status}</Badge>);
    }
    renderStatusDisplay = (rowData) => {
        let resourceKey;
        if (rowData.showtasknotification === 1) {
            resourceKey = rowData.status.toString();
        } else {
            resourceKey = 'none';
        }
        const status = this.quoteStatuses.find(x => x.field === resourceKey);
        if (status) {
            return status.display;
        } else {
            return rowData.status;
        }
    }
    renderCenIdColumn = (rowData) => {
        let abbreviation = 'Rfq-'

        if (rowData.type === 'RFQPM') {
            abbreviation = this.props.notificationAbbreviation_RFQ;
        }

        return abbreviation + Common.Lpad(rowData.requestforquotereference, 5);
    }
    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.REQUESTFORQUOTE_ID", dataField: "requestforquotereference", dataType: 'string', calculateCellValue: this.renderCenIdColumn },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: 'subject' },
            { resource: "GENERAL.FORMS.FIELD.AMOUNT", dataField: 'totalprice', dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "CONTRACT.WF.QUOTES.FIELD.QUOTE_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.ISSUED_BY", dataField: "communicatedby" },
            { caption: this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.PM_RESPONSE_REQUIRED' }, { PM_ABBREVIATION: this.props.globalResources.PM_ABBREVIATION }), dataField: "responserequireddate", dataType: 'date' },
            { caption: this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.PM_RESPONSE_RECEIVED' }, { PM_ABBREVIATION: this.props.globalResources.PM_ABBREVIATION }), dataField: "responsereceiveddate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.renderStatusDisplay },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_BY", dataField: "draftreplyby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "GENERAL.FORMS.FIELD.CURRENCY", dataField: "currency", visible: false, calculateCellValue: this.formatCurrency },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_CREATED_BY", dataField: "replycreatebyname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },
            { resource: "GENERAL.FORMS.FIELD.REPLY_DRAFT_NOTIFIED_TO", dataField: "lastreplydraftednotifiedtoname", visible: false },

        ];

        // if (this.props.fields.TotalPrice) {
        //     columns.push(
        //         { caption: this.props.fields.TotalPrice, dataField: "taskordertotal", dataType: 'currency', currencyCode: this.props.contract.currency },
        //     );
        // }

        const { fields } = this.props.workflowItem;

        if (fields.StartDate.visible) {
            columns.push(
                { caption: fields.StartDate.label, dataField: "startdate", dataType: 'date' },
            );
        }
        if (fields.CompletionDate.visible) {
            columns.push(
                { caption: fields.CompletionDate.label, dataField: "completiondate", dataType: 'date' },
            );
        }


        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));
        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={rfqQuotationCrud.importQuotations}
                        batchDeleteEndpoint={rfqQuotationCrud.deleteQuotationDrafts}
                        batchCommunicateEndpoint={rfqQuotationCrud.communicateQuotationDrafts}
                        onBatchRecordsUpdated={this.fetchQuotes}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={(this.props.workflowItem.userFilters.mainNotice.createAllowed && this.props.baseNotificationReadyForCreate) ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="rfqquotationid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(QuoteListPage);
